import { yupResolver } from "@hookform/resolvers/yup";
import { useMediaQuery } from "@material-ui/core";
import { Box, Stack, TextField, Theme, useTheme } from "@mui/material";
import { useRequest } from "ahooks";
import Button from "components/Overrides/Button/Button";
import { ROUTES } from "helpers/routes";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { serviceGetVisitorByEmail } from "services/api/visitor";
import urlcat from "urlcat";
import * as yup from "yup";

const schema = yup.object().shape({
  email: yup.string().required("Email is required").email("Email is invalid"),
  companyName: yup.string(),
});

const FormCheckInReturnVistor = () => {
  const theme: Theme = useTheme();
  const navigate = useNavigate();

  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isDirty },
  } = useForm<{
    email: string;
    companyName?: string;
  }>({
    mode: "all",
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { loading, run: getVisitorByEmail } = useRequest(
    serviceGetVisitorByEmail,
    {
      manual: true,
      onSuccess: ({ success = false, data = undefined }) => {
        if (success && data) {
          return navigate(urlcat(ROUTES.SELECT_TOPIC, { ...data }));
        }
        navigate(urlcat(ROUTES.CHECK_IN, { ...data, return_visitor: false }));
      },
    }
  );

  const onSubmit = async (data: { email: string; companyName?: string }) => {
    getVisitorByEmail(data.email);
  };

  const onError = (errors: any) => {
    console.log(errors);
  };

  return (
    <Stack spacing={4} alignItems="center">
      <Stack gap={2} direction="row" flexWrap="wrap" style={{ width: "100%" }}>
        <Box style={{ flex: isMobile ? "1 0 100%" : "1 0 46%" }}>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                type="email"
                label="Your work email"
                margin="normal"
                error={!!errors.email}
                helperText={errors.email?.message as string}
              />
            )}
          />
        </Box>
        <Box style={{ flex: "1 0 100%" }}>
          <Controller
            name="companyName"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Company Name"
                margin="normal"
                error={!!errors.companyName}
                helperText={errors.companyName?.message as string}
              />
            )}
          />
        </Box>
      </Stack>

      <Box>
        <Button
          loading={loading}
          variant="contained"
          disabled={!isValid || !isDirty || loading}
          onClick={handleSubmit(onSubmit, onError)}
          style={{ paddingInline: theme.spacing(8) }}
        >
          Done
        </Button>
      </Box>
    </Stack>
  );
};

export default FormCheckInReturnVistor;
